import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { getSchemeLink } from '@ifeng-fe/callapp';
import { CallupHead } from 'ThreeTerminal_mobile_dynamic';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        const pid = getSchemeLink({
            docType: 'phtvsolenewslist',
            pid: content.columnId,
            videoId: content.base62Id,
            noKindFrom: 1,
            kind: 'inter_fhwslmsp01',
            year: content.currentYear,
        });

        const headData = {
            pageInfo: {
                type: 'custom',
                url: content.url,
                id: pid.replace('comifengnewsclient://call?', ''),
                downloads: {
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1505322057584',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8884',
                },
            },
            topClickInfo: {
                behavior: 'action',
                type: 'phtvsole_fx_xd',
                callupKind: 'inter_fhwslmsp01',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'phtvsole_fx_xd',
                callupKind: 'inter_fhwslmsp01',
            },
            hotKeyword: content.headKeyword,
            wxLaunchType: content.wxLaunch.wxLaunchType,
            wxLaunchSwitch: content.wxLaunch.wxLaunchSwitch,
        };

        return <CallupHead content={headData} />;
    }
}

export default errorBoundary(Header);
